
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-black border-t border-gray-800 overflow-hidden">
      {/* Background Watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-5">
        <img 
          src="https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/24151a9b24e2ba5e0b07eb7354fcf6e7.jpeg"
          alt=""
          className="w-[600px] h-auto object-contain"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="mb-6 relative inline-block group">
              {/* Glowing effect */}
              <div className="absolute inset-0 bg-[#D4AF37]/20 blur-xl rounded-full scale-110 group-hover:bg-[#D4AF37]/30 transition-all"></div>
              
              <img 
                src="https://static.readdy.ai/image/74809ee30fca19c1acffe2fc12cb4256/24151a9b24e2ba5e0b07eb7354fcf6e7.jpeg"
                alt="A&H Junk Removal"
                className="relative h-20 w-auto object-contain filter drop-shadow-[0_0_8px_rgba(212,175,55,0.6)] group-hover:drop-shadow-[0_0_12px_rgba(212,175,55,0.8)] transition-all"
              />
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              A father and son team dedicated to providing honest, reliable junk removal services. 
              Built on family values, loyalty, and hard work.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/marketplace/item/1188411236700848/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-full text-gray-400 hover:border-[#D4AF37] hover:text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://instagram.com/a.hjunkremoval"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-full text-gray-400 hover:border-[#D4AF37] hover:text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="font-['Orbitron'] text-white font-semibold mb-6 tracking-wider">NAVIGATION</h5>
            <ul className="space-y-3">
              <li>
                <a href="#home" className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  Home
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  Services
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h5 className="font-['Orbitron'] text-white font-semibold mb-6 tracking-wider">SERVICES</h5>
            <ul className="space-y-3">
              <li className="text-gray-400">Residential Hauling</li>
              <li className="text-gray-400">Commercial Cleanouts</li>
              <li className="text-gray-400">Construction Debris</li>
              <li className="text-gray-400">Yard Waste Removal</li>
              <li className="text-gray-400">Same-Day Service</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} A&H Junk Removal. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-gray-600 text-sm">Family. Loyalty. Service.</span>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-[#D4AF37] text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
